import * as React from 'react';
import PaymentComponent from '../../components/Layout/Payment/Payment';

function Payment() {
    return <PaymentComponent />;
}

export default Payment;
